import Toast from '@/components/common/Toast';
import { ReactNode, createContext, useState } from 'react';

type Props = {
  children: ReactNode;
};

export type ToastProps = {
  id: string;
  message: string;
  onClose: () => void;
  duration?: number;
};

type State = {
  toast: ToastProps;
  addToast: (toast: Omit<ToastProps, 'onClose'>) => void;
  removeToast: () => void;
};

export const ToastContext = createContext<State | null>(null);

export function ToastContextProvider({ children }: Props) {
  const [toast, setToast] = useState<ToastProps>({
    id: '',
    message: '',
    onClose: () => {},
  });

  const removeToast = () => {
    setToast({
      id: '',
      message: '',
      onClose: () => {},
    });
  };

  const addToast = (toast: Omit<ToastProps, 'onClose'>) => {
    setToast({ ...toast, onClose: removeToast });
  };

  return (
    <ToastContext.Provider value={{ toast, addToast, removeToast }}>
      {children}
      <Toast {...toast} />
    </ToastContext.Provider>
  );
}
